import { render, staticRenderFns } from "./FlightSearchReport.vue?vue&type=template&id=ca8c4dfe&"
import script from "./FlightSearchReport.vue?vue&type=script&lang=js&"
export * from "./FlightSearchReport.vue?vue&type=script&lang=js&"
import style0 from "./FlightSearchReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
